// Centralized settings helper for frontend
const KEYS = {
  MASTER: 'fa:masterVolume',
  SFX: 'fa:sfxVolume',
  MUSIC: 'fa:musicVolume',
  SELECTED_SOUND: 'fa:selectedSound',
  TENSAI_GRID_SCALE: 'fa:tensaiGridScale',
  SB_GRID_SCALE: 'fa:sbGridScale',
  CLEAR_EFFECT: 'fa:clearEffect',
  HIDE_EMPTY_TILES: 'fa:hideEmptyTiles',
  TILE_SKIN: 'fa:tileSkin',
  SHOW_INSTRUCTIONS: 'fa:showInstructions',
  SHOW_SB_INSTRUCTIONS: 'fa:showSbInstructions',
  DAILY_PLAYED: 'fa:dailyPlayed',
  DAILY_RESULT: 'fa:dailyResult',
};

const DEFAULTS = new Map([
  [KEYS.MASTER, 50],
  [KEYS.SFX, 100],
  [KEYS.MUSIC, 100],
  [KEYS.SELECTED_SOUND, 'pop_1.wav'],
  [KEYS.TENSAI_GRID_SCALE, 100],
  [KEYS.SB_GRID_SCALE, 100],
  [KEYS.CLEAR_EFFECT, true],
  [KEYS.HIDE_EMPTY_TILES, true],
  [KEYS.TILE_SKIN, 'basic'],
  [KEYS.SHOW_INSTRUCTIONS, true],
  [KEYS.SHOW_SB_INSTRUCTIONS, true],
]);

function hasLocalStorage() {
  try { return typeof window !== 'undefined' && !!window.localStorage; } catch (e) { return false; }
}

function getRaw(key) {
  try {
    if (!hasLocalStorage()) return null;
    return window.localStorage.getItem(key);
  } catch (e) { return null; }
}

const settings = {
  KEYS,
  DEFAULTS,
  getString(key) {
    const v = getRaw(key);
    if (v === null || v === undefined) return String(DEFAULTS.get(key) ?? '');
    return String(v);
  },
  getNumber(key) {
    const v = getRaw(key);
    if (v === null || v === undefined) return Number(DEFAULTS.get(key) ?? 0);
    const n = Number(v);
    return Number.isNaN(n) ? Number(DEFAULTS.get(key) ?? 0) : n;
  },
  getBool(key) {
    const v = getRaw(key);
    if (v === null || v === undefined) return Boolean(DEFAULTS.get(key));
    return v === 'true';
  },
  set(key, value) {
    try {
      if (!hasLocalStorage()) return;
      window.localStorage.setItem(key, String(value));
      try { window.dispatchEvent(new CustomEvent('settingsChanged', { detail: { key, value } })); } catch (e) {}
    } catch (e) {}
  },
  remove(key) {
    try {
      if (!hasLocalStorage()) return;
      window.localStorage.removeItem(key);
      try { window.dispatchEvent(new CustomEvent('settingsChanged', { detail: { key, value: null } })); } catch (e) {}
    } catch (e) {}
  }
};

export default settings;
